export const PAYMENT_METHOD_OPTION_HEIGHT = 3.375;
